module.exports = __webpack_public_path__ + "img/live1.840f81a8.png";